<template>
  <Teleport to="body">
    <Transition
      enter-active-class="transition-opacity duration-200"
      enter-from-class="opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="transition-opacity duration-200"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <div
        v-if="modelValue"
        class="fixed inset-0 z-[10100] flex items-center justify-center bg-white px-6"
      >
        <div class="flex max-w-xs flex-col items-center text-center -translate-y-8">
          <div class="relative h-24 w-24">
            <div class="absolute inset-0 rounded-full border-[12px] border-primary/20" />
            <div
              class="absolute inset-0 animate-spin rounded-full border-[12px] border-transparent border-t-primary border-r-primary"
            />
          </div>
          <p class="mt-6 text-sm text-text-primary">{{ message }}</p>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup lang="ts">
interface Props {
  modelValue: boolean
  message?: string
}

withDefaults(defineProps<Props>(), {
  message: 'Confirming Reservation....',
})
</script>
